__turbopack_context__.v({
  "photo": "avatar-module__8BXzWq__photo",
  "placeholder": "avatar-module__8BXzWq__placeholder",
});
